import React from "react";
import { Card, CardContent, Typography, Button, Menu, MenuItem } from "@mui/material";
import { ArrowDropDown, ArrowUpward, ArrowForward } from "@mui/icons-material";
import "./GenerateReports.css";

const GenerateReports = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card 
      className="custom-card" 
      sx={{ 
        boxShadow: "none", 
        border: "none", 
        padding: 0, 
        borderRadius: "12px", 
        opacity: 0.4, 
        pointerEvents: "none", 
        position: "relative" 
      }}
    >
      <CardContent>
        <div className="title-container">
          <Typography className="title-reports" variant="h6" component="div">
            <h1>Generate Reports</h1>
          </Typography>
          <Button className="buttom-generate"
            variant="contained" 
            onClick={handleClick} 
            sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontSize: '12px', top: '-15px'}} 
            disabled // Deshabilita el botón
          >
            Generate
            <ArrowDropDown sx={{ marginLeft: 1 }} />
          </Button>
        </div>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose}>Option 1</MenuItem>
          <MenuItem onClick={handleClose}>Option 2</MenuItem>
          <MenuItem onClick={handleClose}>Option 3</MenuItem>
        </Menu>

        <div className="elements-container">
          <div className="element">
            <p>Increase Revenue Total</p>
            <h2>$121,649</h2>
            <div className="additional-info">
              <ArrowUpward sx={{ transform: 'rotate(45deg)', color: 'rgba(3, 188, 114, 1)', fontSize: 15 }} />
              <span className="percentage">6,2%</span>
              <span className="from-june"> from June</span>
            </div>
          </div>
          <div className="element">
            <p>Enagagement Analysis</p>
            <h2>74%</h2>
            <div className="additional-info">
              <ArrowUpward sx={{ transform: 'rotate(45deg)', color: 'rgba(3, 188, 114, 1)', fontSize: 15 }} />
              <span className="percentage">1,2%</span>
              <span className="from-june"> from June</span>
            </div>
          </div>
          <div className="element">
            <p>Client Retention</p>
            <h2>86%</h2>
            <div className="additional-info">
              <ArrowUpward sx={{ transform: 'rotate(45deg)', color: 'rgba(3, 188, 114, 1)', fontSize: 15 }} />
              <span className="percentage">12,2%</span>
              <span className="from-june"> from June</span>
            </div>
          </div>
          <div className="element">
            <p>Montly Churn Rate</p>
            <h2>9.02%</h2>
            <div className="additional-info">
              <ArrowForward sx={{ transform: 'rotate(45deg)', color: 'rgba(3, 188, 114, 1)', fontSize: 15 }} />
              <span className="percentage">5,2%</span>
              <span className="from-june"> from June</span>
            </div>
          </div>
        </div>
      </CardContent>

      <Typography 
        variant="h4" 
        component="div" 
        sx={{ 
          position: "absolute", 
          top: "50%", 
          left: "50%", 
          transform: "translate(-50%, -50%)", 
          fontSize: "40px", 
          fontWeight: "bold", 
          color: "rgb(0, 0, 0)", 
          textAlign: "center", 
          zIndex: 10
        }}
      >
        Coming Soon
      </Typography>
    </Card>
  );
};

export default GenerateReports;
